module.exports = __webpack_public_path__ + "static/media/iconValores2.ea103950.svg";